// Aliases

export const ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_HEADER_TITLE
  = 'ALLOCATION_WEIGHTED_SHARE_VALUES_SPREADSHEET_HEADER_TITLE';
